import React, { useState, useEffect, useRef, createRef } from 'react';
import styled from 'styled-components';
import { Container, Anchor, Button } from 'Components/core';
import Hamburger from 'Components/Hamburger';
import { layout, colors } from 'Constants';
import isUrl from 'is-url';
import { disableBodyScroll, enableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock';


import { ApiStore, Subscribe } from 'Store';

// Components
import HamburgerContent from './components/HamburgerContent';
import CODES from 'Root/libs/analytics/CodeDef';

const Header = styled.header`
  position: sticky;
  height: 89px;
  top: 0;
  left: 0;
  right: 0;
  padding: 0 16px;
  background: #fff;
  box-shadow: 0 0 10px 0px #aaa;
  z-index: 100;
`;

const Nav = styled.nav`
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  max-width: ${layout.maxWidth};
  width: 100%;
  height: 100%;
  margin: auto;

  .mobile {
    display: none !important;
  }

  @media screen and (max-width: ${layout.breakpoints.mobile}) {
    .mobile {
      display: flex !important;
    }

    .desktop {
      display: none !important;
    }
  }

  > * + * {
    margin-left: 16px;
  }
  .triangle {
    fill: rgba(0, 70, 45);

    margin-left: 10px;
  }
`;

const NavItemEle = styled.span`
  
  font-family: "Elevance Sans semibold";
font-weight: 600;
font-size: 16px;
line-height: 22px;
text-align: left;
cursor: pointer;
color: ${props => (props.leaf ? '#1355e9' : '#131331')} ;

  
  /*
  position: relative;
  color: ${colors.text};
  transition: 0.2s color;
  cursor: pointer;
  padding: 16px 0;
  font-size:16px ;
  font-weight:bold ;
*/

> .dropdown {
    display: ${props => (props.selected ? 'flex' : 'none')};  
  }
  

> .triangle {
  transition-duration: 0.2s;
  transition-property: transform;
  margin-bottom:2px ;

 
  transform: ${props => (props.selected ? 'rotate(180deg)' : 'rotate(0deg)')};
  

}

  :hover {
    color: ${colors.accent};
  }
 
`;

function useClickOutside(ref, callback) {
  useEffect(() => {
    function handleClickOutside(event) {
      if (ref.current && !ref.current.contains(event.target)) {
        callback();
      }
    }

    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [ref, callback]);
}

const NavItem = props => {
  const ref = useRef(null);
  const [selected, setSelected] = useState(false);
  const handleClickOutside = () => {
    setSelected(false);
  };

  useEffect(() => {
    if (ref.current) {
      const allATags = ref.current.querySelectorAll('a');
      if (allATags.length > 2) {
        const lastTag = allATags[allATags.length - 1];
        lastTag.addEventListener('blur', e => {
          setSelected(false);
        });
      }

      allATags.forEach(aTag => {
        aTag.addEventListener('keydown', e => {
          if (e.key === 'Enter') {
            setSelected(false);
          }
        });
      });
    }
  }, [props.eff]);

  useClickOutside(ref, handleClickOutside);

  return (
    <NavItemEle
      ref={ref}
      onKeyDown={e => {
        if (e.key === 'Enter') {
          setSelected(!selected);
        }
      }}
      selected={selected}
      onClick={e => {
        setSelected(!selected);
      }}
      {...props}
    >
      {props.children}
    </NavItemEle>
  );
};

const NavLink = props => (
  <Anchor {...props} underline={false}>
    <NavItemEle leaf={props.leaf}>{props.children}</NavItemEle>
  </Anchor>
);

const NavDropdown = styled.div`
  position: absolute;
  top: 100%;
  z-index: 10;
  display: flex;
  flex-direction: column;
  width: ${props => (props.width ? props.width : 350)}px;
  padding: 16px;
  background: ${colors.background};
  box-shadow: 2px 2px 1px 1px #aaa;

  > * {
    padding: 8px 4px;
  }
`;

const NavLinkLogo = styled.a.attrs(props => ({
  target: '_blank',
  href: props.to
}))``;

const NavLogo = styled.img`
  max-height: 36px;
  max-width: 45vw;
  height: auto;
  width: auto;
`;

const Triangle = () => {
  return (
    <svg className="triangle" height="5" width="10">
      <polygon points="0,0 10,0  5,5" />
    </svg>
  );
};

// TODO: URL for Logo?
// FIXME: coBrandUrl
export default props => {
  const [hamburgerSelected, setHamburgerSelected] = useState(false);
  const [benefitsOpen, setBenefitsOpen] = useState(true);
  const targetRef=createRef();

  useEffect(()=>{
    //alert(hamburgerSelected)
    //document.body.classList.toggle('no-scroll', !hamburgerSelected);
    if(hamburgerSelected){
      
    
     
      
   
    } 
    else{
     clearAllBodyScrollLocks();            
    }      

  },[hamburgerSelected])

  return (
    <Subscribe to={[ApiStore]}>
      {state => {
        return (
          <Header>
            <Nav>
              <NavLink id="firstEle" code={CODES.HEADER_SITE_VISIT} to={'/'}>
                <NavLogo
                  src={state.brandInfo.logo}
                  alt={state.brandInfo.name}
                />
              </NavLink>
              {state.coBrandLogoURL && (
                <NavLogo src={state.coBrandLogoURL} alt="Co-Brand Logo" />
              )}
              <NavLink to="/" className="desktop" code={CODES.HOME_CLICK}>
                Home
              </NavLink>
              <NavItem
                eff={state.includeMedical}
                tabIndex={0}
                className="desktop"
              >
                Benefits
                <Triangle />
                <NavDropdown className="dropdown">
                  {state.includeMedical && (
                    <NavLink leaf to="/benefits/medical">
                      Medical
                    </NavLink>
                  )}
                  {state.includePharmacy && (
                    <NavLink leaf to="/benefits/pharmacy">
                      Pharmacy
                    </NavLink>
                  )}
                  {state.includeDental && (
                    <NavLink leaf to="/benefits/dental">
                      Dental
                    </NavLink>
                  )}
                  {state.includeVision && (
                    <NavLink leaf to="/benefits/vision">
                      Vision{' '}
                    </NavLink>
                  )}
                  <NavLink leaf to="/benefits/how-plan-works">
                    Understanding Healthcare Terms
                  </NavLink>

                  {state.oeMaterials?.oeBrochure?.oeBrochureURL &&
                    (state?.oeMaterials?.oeBrochure?.oeBrochureURL + '')
                      .length > 0 && (
                      <NavLink leaf to="/benefits/helpful-documents">
                        Helpful documents
                      </NavLink>
                    )}

                  {state.includeLifeDisability && (
                    <NavLink leaf to="/benefits/life-disability">
                      Life and Disability
                    </NavLink>
                  )}

                  {state.includeVoluntary && (
                    <NavLink leaf to="/benefits/voluntary">
                      Supplemental Health
                    </NavLink>
                  )}

                  {state.includeMoreEnrollmentMaterials && (
                    <NavLink leaf to="/benefits/more-materials">
                      More Enrollment Materials
                    </NavLink>
                  )}
                  {state.includeBenefitDetails && (
                    <NavLink leaf to="/benefits/benefit-details">
                    Additional Benefit Information and Resources
                    </NavLink>
                  )}
                  {state.vaInOut && (
                    <NavLink leaf to="/benefits/vaInOut">
                      The Ins and Outs of Coverage
                    </NavLink>
                  )}
                </NavDropdown>
              </NavItem>
              <NavLink className="desktop" to="/find-a-provider">
                Find a Provider
              </NavLink>
              {false && (
                <NavLink className="desktop" to="/wellness-resources">
                  Wellness Resources
                </NavLink>
              )}

              {state?.extraMenu?.length > 0 && (
                <NavItem tabIndex={0} className="desktop">
                  Plan Extras
                  <Triangle />
                  <NavDropdown width={250} className="dropdown">
                    {state?.extraMenu.map(a => {
                      return (
                        <NavLink key={a.code} leaf to={`/plan-extra/${a.code}`}>
                          {a.name}
                        </NavLink>
                      );
                    })}
                  </NavDropdown>
                </NavItem>
              )}

              <NavItem className="desktop">
                <Button to="/contact_us">Additional Information</Button>
              </NavItem>

              <NavItem
                className="mobile"
                onClickCapture={() => setHamburgerSelected(!hamburgerSelected)}
                style={{ padding: '24px 12px' }}
              >
                <Hamburger selected={hamburgerSelected} />
              </NavItem>

              <HamburgerContent
              ref={targetRef}
                state={state}
                style={{ display: hamburgerSelected ? undefined : 'none' }}
                className="mobile"
                closeHamburger={() => setHamburgerSelected(false)}
              />
            </Nav>
          </Header>
        );
      }}
    </Subscribe>
  );
};
